export const environment = {
  userStateApiBaseUrl: (process.env.environmentVariables as any)
    .userStateApiBaseUrl,
  UserManagementApiBaseUrl: (process.env.environmentVariables as any)
    .UserManagementApiBaseUrl,
  featureFlagApiBaseUrl: (process.env.environmentVariables as any)
    .featureFlagApiBaseUrl,
  premiumServiceApiBaseUrl: (process.env.environmentVariables as any)
    .premiumServiceApiBaseUrl,
  premiumHubServiceApiBaseUrl: (process.env.environmentVariables as any)
    .premiumHubServiceApiBaseUrl,
  webHistoryServiceApiBaseUrl: (process.env.environmentVariables as any)
    .webHistoryServiceApiBaseUrl,
  statisticsServiceApiBaseUrl: (process.env.environmentVariables as any)
    .statisticsServiceApiBaseUrl,
  autocompleteServiceApiBaseUrl: (process.env.environmentVariables as any)
    .autocompleteServiceApiBaseUrl,
  mixpanelToken: (process.env.environmentVariables as any).mixpanelToken,
  env: (process.env.environmentVariables as any).ENV,
  isDevelopment:
    (process.env.environmentVariables as any).ENV === 'development',
  isProduction: (process.env.environmentVariables as any).ENV === 'production',
  brazeAppId: (process.env.environmentVariables as any).brazeAppId,
  brazeBaseUrl: 'sdk.iad-07.braze.com',
  sentryConfiguration: {
    dsn: 'https://9a8808978c24d55e1b0dab4e3d4f882e@o4504554485645312.ingest.us.sentry.io/4510296026054656',
  },
  paypalSDKUrl: (process.env.environmentVariables as any).paypalSDKUrl,
  stripeApiKey: (process.env.environmentVariables as any).stripeApiKey,
  googleAuthClientId: (process.env.environmentVariables as any)
    .googleAuthClientId,
  baseUrl: process.env.PUBLIC_URL,
  i18nDebugMode: (process.env.environmentVariables as any).i18nDebugMode,
  cookieDomain: (process.env.environmentVariables as any)
    .cookieDomain as string,
};
